import { render, staticRenderFns } from "./Lexicon.vue?vue&type=template&id=57506d90&scoped=true"
import script from "./Lexicon.vue?vue&type=script&lang=js"
export * from "./Lexicon.vue?vue&type=script&lang=js"
import style0 from "./Lexicon.vue?vue&type=style&index=0&id=57506d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57506d90",
  null
  
)

export default component.exports